import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap-5';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import Results from './results';
import Map from './map';
import OffMarketResults from './off_market_results';
import { selectOffMarketSearch, selectShowMap, selectShowTableView } from '../../store/selectors/ui';
import { selectCallListId } from '../../store/selectors/call_console';
import CallListOffMarketResults from '../../call_list/call_list_off_market_results';

type Props = {
  nominatimUrl: string;
  lastUpdatedMap?: Map<number, Date>;
}

export default function ResultAndMapViewer({ nominatimUrl, lastUpdatedMap }: Props) {
  const showMap = useSelector(selectShowMap);
  const showTableView = useSelector(selectShowTableView);
  const offMarketSearch = useSelector(selectOffMarketSearch);
  const callListId = useSelector(selectCallListId);

  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  const shouldShowMap = showMap || !isMobile;
  const containerRef = useRef<HTMLDivElement | null>(null);

  if (callListId && showTableView) {
    return null;
  }

  const renderResults = () => {
    if (callListId) {
      return (
        <CallListOffMarketResults
          containerRef={containerRef}
          lastUpdatedMap={lastUpdatedMap}
        />);
    } else if (offMarketSearch) {
      return <OffMarketResults containerRef={containerRef} />;
    }
    return (
      <Results containerRef={containerRef} />
    );
  };

  return (
    <Row className="flex-grow-1 overflow-hidden h-100">
      <Col
        className={
          classNames(
            'border-end p-0 bg-body z-0 h-100',
            isMobile && shouldShowMap ? 'd-none' : 'd-block'
          )
        }
        lg={showTableView && offMarketSearch ? 8 : 6}
        xxl={showTableView && offMarketSearch ? 8 : 4}
      >
        {renderResults()}
      </Col>
      <Col className={classNames('px-0', shouldShowMap ? 'd-block' : 'd-none')}>
        <Map nominatimUrl={nominatimUrl} showMap={shouldShowMap} />
      </Col>
    </Row>
  );
}
